<template>
  <form id="billing-info" class="needs-validation" novalidate>
    <input type="hidden" name="plan" id="plan" :value="churchOrder.planCode" />
    <div class="row fullname">
      <div class="col-12 col-md-6">
        <label for="first_name" class>First name *</label>
        <input name="first_name" required class="form-control" v-model="value.firstName" />
      </div>
      <div class="col-12 col-md-6">
        <label for="last_name" class>Last name *</label>
        <input name="last_name" required class="form-control" v-model="value.lastName" />
      </div>
    </div>
    <div class="row">
      <label for="email" class>Email / Login *</label>
      <input
        type="email"
        id="email"
        name="email"
        required
        class="form-control"
        :value="value.email"
      />
    </div>
    <div class="row password">
      <div class="col-12 col-md-6">
        <label for="password" class>Password *</label>
        <input type="password" id="password" name="password" required class="form-control" />
      </div>
      <div class="col-12 col-md-6">
        <label for="passwordConfirmation" class>Password Confirmation *</label>
        <input
          type="password"
          id="passwordConfirmation"
          name="passwordConfirmation"
          required
          class="form-control"
        />
      </div>
    </div>
    <div class="row">
      <label for="church" class>Church Name *</label>
      <input id="church" name="church_name" required class="form-control" />
    </div>
    <div class="row">
      <label for="postal_code" class>Country *</label>
      <strong style="color: #787d85">United States (US)</strong>
      <input type="hidden" name="country" id="country" value="US" readonly="readonly" />
    </div>
    <div class="row address">
      <label for="address_1" class>Street address *</label>
      <input
        id="address_1"
        name="address_1"
        placeholder="House number and street name"
        required
        class="form-control"
      />
      <input
        id="address_2"
        name="address_2"
        placeholder="Apartment, suite, unit etc. (optional)"
        class="form-control"
      />
    </div>
    <div class="row">
      <label for="city" class>Town / City *</label>
      <input id="city" name="city" required class="form-control" />
    </div>
    <div class="row">
      <label for="state" class>State *</label>
      <input id="state" name="state" required class="form-control" />
    </div>
    <div class="row">
      <label for="postcode" class>ZIP *</label>
      <input id="postcode" name="postcode" required class="form-control" />
    </div>
    <div class="row">
      <label for="phone" class>Phone *</label>
      <input id="phone" name="phone" type="tel" required class="form-control" />
    </div>
  </form>
</template>
<script>
export default {
  props: ['value', 'churchOrder']
}
</script>
